"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrokingSlipVersionDetailDto = exports.QuoteEntryDto = exports.InsurerDto = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const swagger_1 = require("@nestjs/swagger");
const class_transformer_1 = require("class-transformer");
class InsurerDto {
}
exports.InsurerDto = InsurerDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 236,
        description: "Unique ID of the insurer",
    }),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], InsurerDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "Navanitha test",
        description: "Name of the insurer",
    }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], InsurerDto.prototype, "insurerName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "Navanitha test",
        description: "Display name of the insurer",
    }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], InsurerDto.prototype, "displayName", void 0);
class QuoteEntryDto {
}
exports.QuoteEntryDto = QuoteEntryDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 19,
        description: "Unique ID of the quote entry",
    }),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], QuoteEntryDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 414,
        description: "Opportunity ID related to the quote entry",
    }),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], QuoteEntryDto.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 577,
        description: "Opportunity Activity ID",
    }),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], QuoteEntryDto.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 6,
        description: "Broking Slip ID the quote is associated with",
    }),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], QuoteEntryDto.prototype, "brokingSlipId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 236,
        description: "Insurer ID selected in the quote",
    }),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], QuoteEntryDto.prototype, "insurerId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 1,
        description: "Status ID of the quote entry",
    }),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], QuoteEntryDto.prototype, "statusId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        type: () => InsurerDto,
        description: "Details of the insurer",
    }),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => InsurerDto),
    tslib_1.__metadata("design:type", InsurerDto)
], QuoteEntryDto.prototype, "insurer", void 0);
class BrokingSlipVersionDetailDto {
}
exports.BrokingSlipVersionDetailDto = BrokingSlipVersionDetailDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 6,
        description: "Unique ID of the broking slip version",
    }),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], BrokingSlipVersionDetailDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 414,
        description: "Associated Opportunity ID",
    }),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], BrokingSlipVersionDetailDto.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 1,
        description: "Version number of the broking slip",
    }),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], BrokingSlipVersionDetailDto.prototype, "brokingSlipVersion", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "sample version I",
        description: "Name of the broking slip version",
    }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], BrokingSlipVersionDetailDto.prototype, "brokingSlipName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        type: [QuoteEntryDto],
        description: "List of quote entries under this broking slip version",
    }),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => QuoteEntryDto),
    tslib_1.__metadata("design:type", Array)
], BrokingSlipVersionDetailDto.prototype, "quoteEntry", void 0);
